<div class="wing-container">
  <nts-loader
    [skipHeader]="false"
    [isVisible]="wingViewModel.onActionInProgress | async">
  </nts-loader>

  <div
    class="wing-container__panel">

    <div class="wing-container__content">
      <ng-container #wingPlaceHolder></ng-container>
    </div>
  </div>
</div>